export default __webpack_public_path__ + "static/Tek_Door-83afd5d81105c1b90877430be7bae432.png";